
import {reactive, ref} from 'vue';
import BasicSettings from './BasicSettings.vue'
import BoxSystem from './BoxSystem.vue'
import { Material, machineTypes, machines, Machine} from '@/logic/calculator';
import { unitType } from 'makerjs';

export default {
    components: {
        BasicSettings,
        BoxSystem
    },

    setup(){

        const unit = ref<string>('Millimeter');

        const machine = ref<Machine>(machines.LASERCUTTER);

        let material = reactive<Material>({
            thickness: undefined,
            type: undefined,
        });

        function updateMaterial(m: Material): void {
            material = m;
        }

        function updateMachine(m: Machine): void {
            machine.value = m;
        }

        function updateUnit(u: string): void {
            console.log(unit.value);
            unit.value = u;
        }

        return {
            material,
            unit,
            unitType,
            machineTypes,
            machine,
            machines,

            // Functions
            updateMaterial,
            updateMachine,
            updateUnit,
        }
    },
}
